import {
  PluginEquifaxPpsrGrantorSearchForm,
  PluginEquifaxPpsrGrantorSearchFormResponse,
} from '../../../types/plugins';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../constants/pluginBasePath';

export const runEquifaxPpsrGrantorSearchForm = (
  constructPost: ConstructPost,
  data: PluginEquifaxPpsrGrantorSearchForm,
): Promise<
  NonPaginatedResponse<PluginEquifaxPpsrGrantorSearchFormResponse> | undefined
> =>
  constructPost<
    NonPaginatedResponse<PluginEquifaxPpsrGrantorSearchFormResponse>
  >(`${PLUGIN_BASE_PATH}/equifax-ppsr-grantor-search-form`, { data });
